import axios from 'axios';
import { ENVIRONMENT_STORAGE_KEY } from '../types/environment';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8002';

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add environment header
client.interceptors.request.use(
  (config) => {
    // Add environment header
    const environment = sessionStorage.getItem(ENVIRONMENT_STORAGE_KEY) || 'sandbox';
    config.headers['X-Environment'] = environment;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if this error came from the session check endpoint
      const isSessionCheck = error.config?.url?.includes('/users/me');
      const isLoginPage = window.location.pathname === '/login';

      // Only redirect if it's not the session check and not already on login page
      if (!isSessionCheck && !isLoginPage) {
        localStorage.removeItem('access_token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
